"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openMeteoApiKey = exports.OPEN_METEO_BASE_URL = void 0;
/** Customer Open-Meteo API root (path suffix is per-request, e.g. `/forecast`). */
exports.OPEN_METEO_BASE_URL = "https://customer-api.open-meteo.com/v1";
function openMeteoApiKey() {
    const apiKey = process.env.OPEN_METEO_API_KEY;
    if (!apiKey)
        throw new Error("OPEN_METEO_API_KEY is not set");
    return apiKey;
}
exports.openMeteoApiKey = openMeteoApiKey;
